import { useLocaleState, useRecordContext, useTranslate } from "react-admin";

import { PatientRecord } from "../types/patient";
import { InfoFieldData, InfoPanel } from "./InfoPanel";

export const PatientInfoPanel = () => {
  const record = useRecordContext<PatientRecord>();
  const translate = useTranslate();
  const [locale] = useLocaleState();

  if (!record) return null;

  const formatBirthDate = (birthDate?: string) => {
    if (!birthDate) return undefined;
    return new Date(birthDate).toLocaleDateString(locale);
  };

  // Build location hierarchy section dynamically
  const physicalLocationFields = (record.locationHierarchy || [])
    .sort((a, b) => b.level - a.level) // Sort from general to specific
    .map(loc => ({
      label: translate(`locationType.${loc.locationType}`),
      value: loc.locationName,
    }));
  const locationFields =
    physicalLocationFields.length > 0
      ? physicalLocationFields
      : [{ label: translate("location"), value: translate("patient.locationNotAssigned") }];

  const sections: InfoFieldData[][] = [
    [
      {
        label: translate("salutationLabel"),
        value: record.salutation ? translate(`salutation.${record.salutation.toLowerCase()}`) : undefined,
      },
      { label: translate("firstName"), value: record.firstName },
      { label: translate("lastName"), value: record.lastName },
    ],
    [
      {
        label: translate("genderLabel"),
        value: translate(`gender.${record.gender}`),
      },
      { label: translate("birthDate"), value: formatBirthDate(record.birthDate) },
    ],
    [
      { label: translate("patientId"), value: record.patientNumber },
      ...(record.email ? [{ label: translate("email"), value: record.email }] : []),
    ],
    [
      { label: translate("organization"), value: record.organizationName },
      ...locationFields, // All locations, dynamically
    ],
  ];

  return <InfoPanel sections={sections} />;
};
